import { render, staticRenderFns } from "./pci-emails.component.vue?vue&type=template&id=6b6a6921"
import script from "./pci-emails.component.js?vue&type=script&lang=js&external"
export * from "./pci-emails.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports